import confetti from 'canvas-confetti';

// Utility function to get window dimensions
export const getWindowSize = (): { height: number; width: number } => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return { height, width };
};

// Function to place confetti at a specific position
export const placeConfetti = (
  x: number, 
  y: number, 
  angle: number = 90, 
  particleCount: number = 100
): void => {
  const { height, width } = getWindowSize();
  const origin = { x: x / width, y: y / height };
  
  confetti({
    origin,
    angle,
    particleCount,
    spread: 360,
  });
};

// Function to trigger confetti animation for a set duration
export const triggerConfetti = (duration: number = 3): void => {
  const finalDuration = duration * 1000; // Use passed duration or fallback to default
  
  const end: number = Date.now() + finalDuration;

  const frame = (): void => {
    confetti({
      particleCount: 7,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
    });

    confetti({
      particleCount: 7,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };

  frame();
};
